import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { Contabilidad, ContabilidadObject, ContabilidadResponse } from '@p-p-portafolio/promociones/interfaces/contabilidad';
import { CampoTablaWhereService } from '@shared/services/campo-tabla-where.service';
import { ConceptosService } from '@p-p-portafolio/services/conceptos.service';
import { OpcionesService } from '@p-p-portafolio/services/opciones.service';
import { ContabilidadService } from '@p-p-portafolio/promociones/services/contabilidad.service';
import { ContabilidadPromocionComponent } from '../contabilidad-promocion.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SwalService } from '@shared/utils/swal.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Opciones } from '@p-p-portafolio/interfaces/opciones';
import { OpcionesRequest } from '@shared/interfaces/request/opciones';
import { ParametrosvariablesService } from '@p-parametria/parametros/services/parametrosvariables.service';
import { EmpresasService } from '@p-parametria/mantenimiento/abc-empresas/services/empresas.service';
import { IGetCuentasReq } from '@p-parametria/mantenimiento/abc-empresas/interfaces/ICuentas';

@Component({
  selector: 'app-contabilidad-form',
  templateUrl: './contabilidad-form.component.html',
  styleUrls: ['./contabilidad-form.component.css']
})
export class ContabilidadFormComponent implements OnInit {
  origenList: any[] = [];
  tipoMovList: any[] = [];
  conceptos: any;
  catalogo: any;
  opcionesRequestModel: OpcionesRequest;
  public loading: boolean;
  public promocion: string = '';
  public empresa: string = '';
  constructor(
    private _conceptosService: ConceptosService,
    private empresasService: EmpresasService,
    private fb: UntypedFormBuilder,
    private _contabilidadService: ContabilidadService,
    private _parametrosVariables: ParametrosvariablesService,
    private _dialogRef: MatDialogRef<ContabilidadPromocionComponent>,
    private _swalService: SwalService,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public model: ContabilidadObject
  ) {
    // Obtener promoción y empresa de los datos del diálogo
    this.promocion = this.model?.promocion || '';
    this.empresa = this.model?.empresa || '';
    
    
    if (this.model && this.model.data) {
      const setModel: Contabilidad = {
        let_origen: model.data.let_origen,
        let_tipomov: model.data.let_tipomov,
        iConcepto: model.data.iConcepto,
        iSubConcepto: model.data.iSubConcepto,
        sCuenta: model.data.sCuenta,
        sCuenta12: model.data.sCuenta12,
        sContra: model.data.sContra,
        sContra12: model.data.sContra12,
        sPromocion: localStorage.getItem('promocion'),
        iOrigen: model.data.iOrigen,
        iTipoMov: model.data.iTipoMov,
        sTablaCuenta: model.data.sTablaCuenta,
        sTablaContra: model.data.sTablaContra,
        sTablaCuenta12: model.data.sTablaCuenta12,
        sTablaContra12: model.data.sTablaContra12,
        DesConcepto: '',
        DescSub: '',
        vCuenta: '',
        vContra: ''
      };
      this.form.setValue(setModel);
      this.form.controls['iConcepto'].disable();
      this.form.controls['iSubConcepto'].disable();
      this.form.controls['let_origen'].disable();
      this.form.controls['let_tipomov'].disable();
    }
  }
  form = this.fb.group({
    let_origen: ['', Validators.required],
    let_tipomov: ['', Validators.required],
    DesConcepto: [''],
    DescSub: [''],
    iConcepto: ['', Validators.required],
    iSubConcepto: ['', Validators.required],
    sCuenta: [''],
    sCuenta12: [''],
    sContra: [''],
    sContra12: [''],
    sPromocion: this.promocion,
    iOrigen: [''],
    iTipoMov: [''],
    sTablaCuenta: [''],
    sTablaContra: [''],
    sTablaCuenta12: [''],
    sTablaContra12: [''],
    vCuenta: [''],
    vContra: ['']
  });

  ngOnInit(): void {
    this.cargarOrigen();
    this.cargarTipo();
    this.cargarConceptos();
    this.cargarTiposCredito(
      this.model && this.model.data ? this.model.data.sCuenta : '',
      this.model && this.model.data ? this.model.data.sContra : '',
      this.model && this.model.data ? this.model.data.sCuenta12 : '',
      this.model && this.model.data ? this.model.data.sContra12 : ''
    );
  }

  cargarOrigen() {
    this.opcionesRequestModel = {
      tabla: 'catbl_ctascont',
      campo: 'iOrigen'
    };
    this._parametrosVariables.Getcmspr_opciones(this.opcionesRequestModel.tabla, this.opcionesRequestModel.campo).subscribe((res: Opciones[]) => {
      this.origenList = res;
      if (this.model && this.model.data) {
        const origen = this.origenList.find((opcion) => opcion.sOpcion === this.model.data.let_origen);
        if (origen) {
          this.form.controls['let_origen'].patchValue(origen.sValor);
          this.form.controls['let_origen'].disable();
        } else {
          console.warn('No se encontró el valor en opciones');
        }
      }
    });
  }

  cargarTipo() {
    this.opcionesRequestModel = {
      tabla: 'catbl_ctascont',
      campo: 'iTipoMov'
    };
    this._parametrosVariables.Getcmspr_opciones(this.opcionesRequestModel.tabla, this.opcionesRequestModel.campo).subscribe((res: Opciones[]) => {
      this.tipoMovList = res;
      if (this.model && this.model.data) {
        const movimiento = this.tipoMovList.find((dato) => dato.sOpcion === this.model.data.let_tipomov);
        if (movimiento) {
          this.form.controls['let_tipomov'].patchValue(movimiento.sValor);
          this.form.controls['let_tipomov'].disable();
        }
      }
    });
  }

  cargarConceptos() {
    this._conceptosService.getAll().subscribe((res) => {
      this.conceptos = res;
    });
  }

  cargarTiposCredito(sCuenta: string, sContra: string, sCuenta12: string, sContra12: string) {
    const sEmpresa = this.model ? this.model.empresa : this.empresa;
    const payload: IGetCuentasReq = {
      sUsuario: JSON.parse(sessionStorage.getItem('user')),
      sEmpresa: sEmpresa,
      sCuenta: '',
      sDescripcion: '',
      sClaveContabilidadDeb: '',
      sClaveContabilidadCre: ''
    };
    this.empresasService.GetCuentas(payload).subscribe((res) => {
      this.catalogo = res.data;
      this.form.controls['sCuenta'].patchValue(sCuenta);
      this.form.controls['sContra'].patchValue(sContra);
      this.form.controls['sCuenta12'].patchValue(sCuenta12);
      this.form.controls['sContra12'].patchValue(sContra12);
    });
  }

  mapForm() {
    this.form.controls['iConcepto'].enable();
    this.form.controls['iSubConcepto'].enable();
    this.form.controls['let_origen'].enable();
    this.form.controls['let_tipomov'].enable();
    const item: Contabilidad = {
      let_origen: this.form.value.let_origen,
      DesConcepto: this.form.value.let_origen,
      DescSub: this.form.value.let_tipomov,
      let_tipomov: this.form.value.let_tipomov,
      iConcepto: parseInt(this.form.value.iConcepto),
      iOrigen: this.form.value.let_origen,
      iSubConcepto: this.form.value.iSubConcepto,
      iTipoMov: this.form.value.let_tipomov,
      sContra: this.form.value.sContra,
      sContra12: this.form.value.sContra12,
      sCuenta: this.form.value.sCuenta,
      sCuenta12: this.form.value.sCuenta12,
      sPromocion: this.promocion,
      sTablaContra: '',
      sTablaContra12: '',
      sTablaCuenta: '',
      sTablaCuenta12: '',
      vContra: '',
      vCuenta: ''
    };
    return item;
  }

  continue() {
    if (this.model && this.model.data) {
      this.update(this.form.value);
    } else {
      this.agregar(this.form.value);
    }
    this._dialogRef.close();
  }

  agregar(model: Contabilidad) {
    this._contabilidadService.add(this.mapForm()).subscribe((res) => {
      this.loading = false;
      if (res != null) {
        this._dialogRef.close(true);
        this._swalService.success('Agregado');
      } else this._swalService.error('No Agregado');
    });
  }

  update(model: Contabilidad) {
    this._contabilidadService.update(this.mapForm()).subscribe((res) => {
      this.loading = false;
      if (res != null) {
        this._dialogRef.close(true);
        this._swalService.success('Actualizado');
      } else this._swalService.error('No Actualizado');
    });
  }

  close() {
    this._dialogRef.close();
  }
}
